<template>
  <b-modal
    hide-footer
    id="modal-add-complaint-group"
    ref="modal-add-complaint-group"
    size="xl"
    title="จัดกลุ่มเรื่องร้องทุกข์"
  >
    <!-- <b-button @click="BESTEST">ทดสอบ</b-button><br></br>
    <span>complaintGroupId {{this.complaintGroupId}}</span><br></br>
    <span>complaintGroupCode {{this.complaintGroupCode}}</span><br></br>
    <span>complaintGroupIssue {{this.complaintGroupIssue}}</span><br></br> -->

    <div class="container">
      <b-overlay :show="showOverlay" rounded="sm">

        <b-card class="text-center">
          <!-- <span>Mode Groop : {{this.modeGrp}}</span><br></br> -->
          <span v-if="this.complaintGroupId === '' || this.complaintGroupId === null || this.complaintGroupId === undefined">
            <!-- เพิ่มเรื่องร้องทุกข์เข้ากลุ่มใหม่ [{{modeGrp}}] -->
            เพิ่มเรื่องร้องทุกข์เข้ากลุ่มใหม่
          </span>
          <span v-else>
            <!-- เพิ่มเรื่องร้องทุกข์เข้ากลุ่ม : {{ this.complaintGroupCode }} [{{modeGrp}}] -->
            เพิ่มเรื่องร้องทุกข์เข้ากลุ่ม : {{ this.complaintGroupCode }}
          </span>
        </b-card>

        <!-- ค้นหา -->
        <b-card class="mt-2 col-12">
          <b-col cols="12">
            <SearchFilter
              ref="searchFilter"
              :mode="modeGrp"
              :autoSearch="true"
              @handleSubmit="searchFilterSubmit"
            />
          </b-col>
        </b-card>

        <!-- กรุณากรอกรายละเอียดการจัดกลุ่มเรื่องร้องทุกข์ -->
        <!-- <b-card class="mt-2 col-12">
          <b-form-group label="รายละเอียดการจัดกลุ่มเรื่องร้องทุกข์">
            <b-form-input
              v-model="textNote"
              required
            />
          </b-form-group>
        </b-card> -->
        <ValidationObserver ref="form">
          <b-card class="mt-2 col-12">
            <b-form-group>
              <label for="noteComplaintGroup">รายละเอียดการจัดกลุ่มเรื่องร้องทุกข์ 
                <span class="text-danger">*</span>
              </label>
              <ValidationProvider
                rules="required"
                name="กรุณากรอกรายละเอียดการจัดกลุ่มเรื่องรองทุกข์"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="noteComplaintGroup"
                  v-model="complaintGroupIssue"
                  placeholder="กรุณากรอกรายละเอียดการจัดกลุ่มเรื่องรองทุกข์"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-card>
        </ValidationObserver>

        <!-- ตาราง เลือกจัดกลุ่มร้องทุกข์ -->
        <b-card class="mt-2 col-12">
          <b-col cols="12">
            <CommonTable
              ref="tableCommon"
              :routeName="$route.name"
              :tableHeader="tableHeader"
              :searchMode="modeGrp"
              :isOption="true"
              @handle-select="onSelectChange"
              @handleOverlay="setOverlay"
            />
          </b-col>
          <footer
            id="modal-transfer___BV_modal_footer_"
            class="modal-footer d-flex justify-content-between"
          >
            <button
              type="button"
              class="btn btn-secondary"
              block
              @click="onCancel"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn btn-primary"
              block
              @click="onSubmitToGroup"
            >
              บันทึกกลุ่มร้องทุกข์
            </button>
          </footer>
        </b-card>

        <!-- Pending -->
        <!-- ตาราง ผลลัพธ์จากการจัดกลุ่มร้องทุกข์ -->

      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BOverlay,
  BCard,
} from "bootstrap-vue";

import VueSelect from "vue-select";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

import appsetting from "@/store/app-settings/index.js";

import CommonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import CommonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";

import * as userData from "@/auth/localStorageUtils.js";
import * as complaintGroupStore from "@/store/api/complaint/complaintGroup.js";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BOverlay,
    VueSelect,
    CommonTable,
    SearchFilter,
    ValidationObserver,
    ValidationProvider,
    extend,
  },
  props: {
    modeGrp: "",
    isInGroup: false,
    complaintGroupId: null,
    complaintGroupCode: null,
    complaintGroupIssue: null,
    componentName: null,   
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      selects: [],
      showOverlay: false,
      roleSelect: null,
      roles: [],
      tableHeader: CommonTableHeader,
      textNote: '',

      departmentReq: '',
      userActiveReq: '',
    };
  },
  created() {
    extend("checkRequired", {
      validate(value) {
        return {
          required: true,
          // valid: _this.tab3check(),
        };
      },
      message: "{_field_}",
      computesRequired: true,
    });

    // this.setNote(); // ใช้สำหรับเปลี่ยนข้อความรายละเอียดจัดกลุ่มร้องทุกข์
  },
  mounted() {

  },
  methods: {
    onOpenModal() {
      const _this = this;
      console.log("modeGrp", this.modeGrp);
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    searchFilterSubmit(params) {
      const _this = this;
      if(this.modeGrp === "Screening") {
        /// เพิ่มเติมว่าตอนนี้คัดกรองจะต้องส่ง userData.departmentId ไปด้วยแล้ว ตาม COMPLAINT-1168
        params.departmentId = userData.departmentId();
      }else if(this.modeGrp === "Officer") {
        params.departmentId = userData.departmentId();
        params.userActive = userData.userId();

      }else if(this.modeGrp === "LawOfficer") {
        params.departmentId = userData.departmentId();
        params.userActive = userData.userId();
      }

      params.tabName = "All";
      params.isInGroup = this.isInGroup;

      console.log("searchFilterSubmit", params);

      this.$refs.tableCommon.onSearchSubmit(params);
    },
    onSubmitToGroup() {
      const _this = this;

      // console.log("onSubmitToGroup $refs", _this.$refs);

      if (this.complaintGroupIssue === null || this.complaintGroupIssue === '' || this.complaintGroupIssue === undefined) {
        this.$bvToast.toast("กรุณากรอกรายละเอียดการจัดกลุ่มเรื่องร้องทุกข์", {
          title: `รายละเอียดการจัดกลุ่มเรื่องร้องทุกข์`,
          variant: "danger",
          solid: false,
        });
        console.log("Validate[False] : รายละเอียดการจัดกลุ่มเรื่องร้องทุกข์")
        return;
      }

      if (this.selects.length < 1) {
        this.$bvToast.toast("กรุณาเลือกเรื่องร้องทุกข์ที่จะเพิ่มเข้ากลุ่มอย่างน้อย 1 รายการ", {
          title: `เลือกเรื่องร้องทุกข์เข้ากลุ่ม`,
          variant: "danger",
          solid: false,
        });
        console.log("Validate[False] : เลือกเรื่องร้องทุกข์เข้ากลุ่ม")
        return;
      }

      // เอาเฉพาะ complaint id
      const complaintIds = this.selects.map((value) => {
        return value.complaintId;
      });
      // console.log("complaintIds", complaintIds);

      // พารามิเตอร์
      if(this.modeGrp === "Screening") {
        /// this.departmentReq = appsetting.complaintdepartmentId.screening;
        /// เปลี่ยนให้ใส่ userData.departmentId() แทนแล้วสำหรับคัดกรอง
        this.departmentReq = userData.departmentId();
        this.userActiveReq = null;
      }
      else if(this.modeGrp === "Officer" || this.modeGrp === "LawOfficer") {
        this.departmentReq = userData.departmentId();
        this.userActiveReq = userData.userId();
      }
      // else if(this.modeGrp === "LawOfficer") {
      //   this.departmentReq = appsetting.complaintdepartmentId.lawOfficer;
      //   this.userActiveReq = userData.userId();
      // }
      // console.log("departmentReq / userActiveReq", this.departmentReq, this.userActiveReq);
      
      // พารามิเตอร์จัดกลุ่มเรื่องร้องทุกข์
      const paramsIns = {
        // params name = complaintGroupId 
        // : ในกรณีที่เป็นการเพิ่มเข้ากลุ่มใหม่ หลังบ้าน Generate  
        // : ในกรณีที่เพิ่มเข้ากลุ่มที่เคยถูกสร้างไปแล้ว เอา GroupId มาใส่
        complaintGroupId: this.complaintGroupId,
        complaintIds: complaintIds,
        departmentId: this.departmentReq,
        userActive: this.userActiveReq,
        complaintGroupDetail: this.complaintGroupIssue,
        provinceCode: null // ส่วนนี้เดี๋ยวมาใส่เพิ่มหลังปรับ API 
      };
      console.log("พารามิเตอร์จัดกลุ่มเรื่องร้องทุกข์", paramsIns, userData.userId());

      complaintGroupStore
        .addComplaintGroup(paramsIns, userData.userId())
        .then(function(response) {
          // handle success

          console.log("addComplaintGroup", response);

          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            // console.log("addComplaintGroup $refs", _this.$refs);

            // เรียก searchFilter อีกครั้ง เนื่องจากหลังปรับ API จะไม่เอาตัวที่จัดกลุ่มไปแล้วขึ้นมาแสดง
            _this.$refs.searchFilter.onSearchBtnClicked();
        
            // reset form-input [noteComplaintGroup]
            // this.$refs["noteComplaintGroup"].value = "";
            _this.complaintGroupIssue = "";
            

          } else {
            _this.$bvToast.toast(response.data.message, {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch(function(error) {
          _this.$bvToast.toast(error, {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        })
        .then(function() {
          // always executed
          // console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    onCancel() {
      this.$refs["modal-add-complaint-group"].hide();
    },
    onSelectChange(selects) {     
      console.log("onSelectChange", selects);
      this.selects = selects;
    },
    selectOnInput() {
      this.$forceUpdate();
    },
    BESTEST() {
      console.log("appsetting", appsetting.complaintdepartmentId);
      console.log("userId", userData.userId());
    },
    setNote() {
      console.log("แสดง props", this.props);
      console.log("แสดง complaintGroupId", this.complaintGroupId);
      console.log("แสดง complaintGroupIssue", this.complaintGroupIssue);
      console.log("แสดง complaintGroupCode", this.complaintGroupCode);
      console.log("แสดง textNote", this.textNote);

      if(this.complaintGroupIssue === null || this.complaintGroupIssue === '' || this.complaintGroupIssue === undefined) {
        this.textNote = '';
      } else {
        this.textNote = this.complaintGroupIssue;
      }
      console.log("แสดง textNote หลังเปลี่ยนแปลง", this.textNote);
    }
  },
};
</script>

<style></style>